import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'MODALS/RECIPIENTS_MODAL';

export const {action: show} = createAction(`${domain}/SHOW`, (originatorId, smsIdentifier) => ({
    originatorId,
    smsIdentifier,
}));

export const {action: showRecipients} = createAction(`${domain}/SHOW_RECIPIENTS`, (recipients, smsIdentifier) => ({
    recipients,
    smsIdentifier,
}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {
    action: fetchRecipients,
    success: fetchRecipientsSuccess,
    failed: fetchRecipientsFailed,
} = createAction(
    `${domain}/FETCH_RECIPIENTS`,
    originatorId => ({originatorId}),
    recipients => ({recipients}),
);
